import { render } from "./back-home-navigation.vue?vue&type=template&id=f13072a2&scoped=true"
import script from "./back-home-navigation.vue?vue&type=script&lang=js"
export * from "./back-home-navigation.vue?vue&type=script&lang=js"

import "./back-home-navigation.vue?vue&type=style&index=0&id=f13072a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f13072a2"]])

export default __exports__